import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import Translate from 'components/Translate';

import config from 'config';
import BlueButton from "../../../../../../components-new/buttons/BlueButton";
import {silverInfoStyles} from "../../../../../../utils/General";

const styles = {
    header: {
        width: '70%',
        maxWidth: '1063px',
        margin: '0 auto'
    },
    instructionsTitle: {
        color: '#3d568f',
        marginBottom: '20px',
        fontSize: '1rem',
        textAlign: 'left',
        width: '100%',
        fontWeight: '200'
    },
    integrationCode: {
        backgroundColor: '#F2F5FC',
        padding: '20px',
        height: '115px',
        width: '100%',
        border: 'none',
        resize: 'none',
        borderRadius: '20px'
    },
    copyCodeButtonWrapper: {
        textAlign: 'center',
        marginTop: '10px',
    },
    copyCodeButton: {
        backgroundColor: '#043e5c',
        borderRadius: '20px',
        padding: '15px',
        width: '135px',
        fontSize: '16px',
        color: '#FFFFFF',
        ':focus': {
            backgroundColor: 'rgba(4,62,92,0.74)',
        },
        // float: 'right',
        display: 'block',
        margin: '0 auto'
    },
};

class IntegrationCode extends Component {
    constructor(props) {
        super(props);
        this.codeRef = React.createRef();
    }

    static getIntegrationCode(client) {
        const uri = encodeURI(`${config.WEBCHAT_HOST}/sdk.bundle.js?version=${config.WEBCHAT_VERSION}&companyId=${client.id}`);
        return `<script id="TSChatSDK" type="text/javascript" src="${uri}"/></script>`;
    }

    copyCodeToClipBoard = () => {
        this.codeRef.current.select();
        document.execCommand('copy');
    };

    render() {
        const {client, commonStyles} = this.props;
        const integrationCode = IntegrationCode.getIntegrationCode(client);


        return (
            <div style={[styles.header]}>
                <div>
                    <h2 style={{...silverInfoStyles.info, marginLeft: '0px', marginBottom: '20px', textAlign: 'center'}}>
                        <Translate text="webchatIntegrationText"/>
                        <p>curl --location --request POST '{config.WEBBACK_HOST}/encrypt-username?username=testusername'</p>
                    </h2>
                    <textarea
                        style={[styles.integrationCode, commonStyles.bottomMargin]}
                        defaultValue={integrationCode}
                        readOnly
                    />
                    <textarea
                        style={{
                            position: 'fixed',
                            top: -10,
                            left: -10,
                            width: 1,
                            height: 1,
                            resize: 'none',
                            border: 'none',
                            padding: 0,
                        }}
                        ref={this.codeRef}
                        defaultValue={integrationCode}
                        readOnly
                    />
                    <div style={[styles.copyCodeButtonWrapper]}>
                        <BlueButton
                            width={'130px'}
                            children={<Translate text={'copy'}/>}
                            onClick={this.copyCodeToClipBoard}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

IntegrationCode.propTypes = {
    client: PropTypes.object.isRequired,
    commonStyles: PropTypes.object.isRequired,
};

export default Radium(IntegrationCode);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/webchat-conf/IntegrationCode.jsx